import { FeatureFlags } from '../app/core/models/feature-flags.model';

export const environment = {
  production: false,
  bypassAuth: true,
  trendApiBaseUrl: 'https://api.trending.silverpush.live/api/v1',
  // Intentionally empty: the trending credential lives on the BFF and must
  // never ship in a browser bundle. Calls go through /api/trends/raw/*.
  trendApiToken: '',
  // Relative path — Angular dev server proxies /api → http://localhost:3000
  // via proxy.conf.json. Keeps requests same-origin so CORS doesn't kick in.
  apiBaseUrl: '/api',
  // The context-agent host for the Forecast screen's chart/placement calls.
  // This was HARDCODED to the QA host in source, so production browsers
  // called QA infrastructure directly, cross-origin and unauthenticated.
  contextAgentBaseUrl: '/api/forecast-proxy',
  planApiBaseUrl: 'https://acmqa.api.silverpush.live/plan/v1',
  planApiToken: '',
  authCheckUrl: 'https://acmqa.api.silverpush.live/um/api/v1/auth/check-auth',
  logoutUrl: 'https://acmqa.api.silverpush.live/um/api/v1/auth/logout',
  loginRedirectUrl: 'https://acmqa.silverpush.live/login',

  featureFlags: {
    platforms: {
      youtube:       { enabled: true,  label: 'YouTube',           trendSource: true,  sampleList: true  },
      tiktok:        { enabled: true,  label: 'TikTok',            trendSource: true,  sampleList: false },
      meta:          { enabled: true,  label: 'Meta',              trendSource: false, sampleList: false },
      ctv:           { enabled: true,  label: 'CTV',               trendSource: false, sampleList: false },
      programmatic:  { enabled: false, label: 'Programmatic Web',  trendSource: false, sampleList: false },
    },
    features: {
      // TikTok plans (generation only). Off until enabled here; an absent key is off.
      'tiktok.planning': true,
      // TikTok signals (spec §9.5): the backend's and the BFF's TIKTOK_SIGNALS_ENABLED.
      'tiktok.signals': true,    // LOCAL: on for the docker test stack
      'tiktok.forecast': true,   // LOCAL: on for the docker test stack
      // Programmatic CTV plans (generation only; Programmatic CTV spec §4.1).
      'programmatic-ctv.planning': true,
      aiDeduplication:  true,
      intensityScoring: true,
      youtubeSegments:  true,
      prebuiltSegments: true,
    },
    defaultCategories: [
      'Alcohol', 'Automobiles', 'Beauty & Makeup', 'Business & Finance', 'Comedy',
      'Education', 'Fashion', 'Food & Cooking', 'Gaming', 'Generational Cohorts',
      'Health & Fitness', 'History', "Kids' Content", 'Lifestyle', 'Movies & Entertainment',
      'Music', 'NFL', 'News', 'Podcast', 'Science', 'Sporting Events', 'Sports',
      'Technology', 'Travel',
    ],
  } as FeatureFlags,
};
